import React, { useEffect, useRef, useState } from "react";

const steps = [
  { id: 1, title: "Identity Verification" },
  { id: 2, title: "Personal & Address Details" },
  { id: 3, title: "Bank / Payment Verification" },
  { id: 4, title: "Review & Submit" },
];

const StepSidebar = ({ currentStep }) => {
  const sidebarRef = useRef(null);
  const [progressSize, setProgressSize] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const [totalSize, setTotalSize] = useState(0);
  const [progressStart, setProgressStart] = useState(0);

  // Detect resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Calculate progress
  useEffect(() => {
    const sidebar = sidebarRef.current;
    if (!sidebar) return;

    const circles = sidebar.querySelectorAll(".step-circle");
    if (!circles.length) return;

    const first = circles[0];
    const active = circles[currentStep - 1];

    if (isMobile) {
      const sidebarLeft = sidebar.getBoundingClientRect().left;

      const firstCenter =
        first.getBoundingClientRect().left -
        sidebarLeft +
        first.offsetWidth / 2;

      const activeCenter =
        active.getBoundingClientRect().left -
        sidebarLeft +
        active.offsetWidth / 2;

      const last = circles[circles.length - 1];

      const lastCenter =
        last.getBoundingClientRect().left - sidebarLeft + last.offsetWidth / 2;

      setProgressStart(firstCenter);
      setProgressSize(activeCenter - firstCenter);
      setTotalSize(lastCenter - firstCenter);
    } else {
      const sidebarTop = sidebar.getBoundingClientRect().top;

      const start =
        first.getBoundingClientRect().top - sidebarTop + first.offsetHeight / 2;

      const end =
        active.getBoundingClientRect().top -
        sidebarTop +
        active.offsetHeight / 2;

      setProgressSize(end - start);
    }
  }, [currentStep, isMobile]);

  return (
    <div className="step-sidebar" ref={sidebarRef}>
      <div
        className="step-line"
        style={
          isMobile
            ? {
                width: `${totalSize}px`,
                left: `${progressStart}px`,
              }
            : {}
        }
      ></div>

      <div
        className="step-line-progress"
        style={
          isMobile
            ? {
                width: `${progressSize}px`,
                left: `${progressStart}px`,
              }
            : { height: `${progressSize}px` }
        }
      ></div>

      {steps.map((step) => (
        <div
          key={step.id}
          className={`step-item 
            ${currentStep === step.id ? "active" : ""}
            ${currentStep > step.id ? "completed" : ""}
          `}
        >
          <div className="step-circle"></div>
          <div className="step-text">
            <p>Step {step.id}</p>
            <span>{step.title}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StepSidebar;
